import { DatamodelGroup } from './datamodel.types'

export const DATAMODEL_GROUPS_LABELS = {
  [DatamodelGroup.LOOKUP]: 'Lookup',
  [DatamodelGroup.COMPUTED]: 'Custom',
  [DatamodelGroup.INCOME]: 'Income',
  [DatamodelGroup.OPEX]: 'OPEX',
  [DatamodelGroup.LEDGER]: 'Ledger',
}
